import { useEffect } from "react";

// Shared Escape handler for modal-like surfaces. Every modal should
// close on Escape for keyboard users; doing it once here keeps the
// behaviour consistent (and means a future focus-trap upgrade is
// one-file). Not a full a11y solution — doesn't trap Tab focus — but
// it covers the most common keyboard-user expectation.
export function useModalEscape(onClose: () => void) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose();
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
}
